import { Component, Input } from '@angular/core';
import { PlansService } from 'src/app/components/plans/plans.service';
import { SubscriptionService } from 'src/app/billing/services/subscription.service';
import { HelpWidgetService } from 'src/app/app-common/services/help-widget.service';

@Component({
  selector: 'pending-change-alert',
  templateUrl: './pending-change-alert.component.html',
  styleUrls: ['./pending-change-alert.component.scss'],
  standalone: false,
})
export class PendingChangeAlertComponent {
  @Input() isUpdate: boolean;
  @Input() upgrade: boolean;
  @Input() licenseQuantityMultiplier = 1;
  @Input() unitLabel = 'display licenses';

  getDisplayQuantity(quantity: number | undefined | null): number {
    const value = quantity ?? 0;
    return value * this.licenseQuantityMultiplier;
  }

  getChangedPlanQuantity(): number {
    return (
      this.subscriptionService.getItemSubscription()?.changed_plan_quantity ?? 0
    );
  }

  getCurrentPlanQuantity(): number {
    return this.subscriptionService.getItemSubscription()?.plan?.quantity ?? 0;
  }

  getPlanName(planId): any {
    if (!planId || !this.plansService.getPlanById(planId)) {
      return '';
    }

    return this.plansService.getPlanById(planId).name;
  }

  constructor(
    private plansService: PlansService,
    public subscriptionService: SubscriptionService,
    public helpWidgetService: HelpWidgetService,
  ) {}
}
